import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector   : 'wor-dealers-terms-and-conditions',
  template: require('./dealers.terms-and-conditions.component.html')
})
export class DealersTermsAndConditionsComponent {
  @Input() settings: any;

  constructor (
    public activeModal: NgbActiveModal
  ) {}
}
